import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/public/icons/popeyes-not-found.svg");
;
import(/* webpackMode: "eager" */ "/workspace/public/poppy.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/cupom-item.tsx");
